import styled from 'styled-components';
import { Button } from 'antd';
import React from 'react';

export interface ButtonJoinProps {
  displayText?: string;
  onClick?: () => any;
  eventExpiredOrHidden?: boolean
}

const StyledButton = styled(Button)`   
  box-shadow: 0 0 20px #eee;
  background: rgba(245,128,2,1);
  background: linear-gradient(279deg, rgba(2,0,36,1) 0%, rgba(252,201,62,1) 0%, rgba(245,128,2,1) 100%);
  border: none !important;

  &:hover {
    background: linear-gradient(279deg, rgba(2,0,36,1) 0%, rgba(252,201,62,1) 0%, rgba(245,128,2,1) 100%);
  }
`;

const ButtonJoin: React.FC<ButtonJoinProps> = ({ displayText, onClick, eventExpiredOrHidden }) => {
  return (
    <StyledButton
      size='large'
      type='primary'
      onClick={onClick}
      disabled={eventExpiredOrHidden}
      style={{ textAlign: 'center' }}
    >
      {displayText}
    </StyledButton>
  );
};

export default ButtonJoin;